import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=6b74db18&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.scss?vue&type=style&index=0&id=6b74db18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74db18",
  null
  
)

export default component.exports